import { z } from 'zod';
/**
 * Cartes bancaires mises à la disposition des agents de voyage.
 * Leur disponibilité est pilotée au runtime depuis le back-office
 * (table `app_settings`, clés `cb_card_<type>`), et n'est qu'informative :
 * elle n'ouvre ni ne ferme aucun moyen de paiement dans l'application.
 */
export const AGENCY_CARD_TYPES = ['CASH', 'DIFFERE', 'FPVCN'];
export const agencyCardTypeSchema = z.enum(AGENCY_CARD_TYPES);
export const updateCardAvailabilitySchema = z.object({
    cardType: agencyCardTypeSchema,
    isActive: z.boolean(),
});
